<template>
  <div class="video" :style="'background-image: url('+cover+');'">
    <iframe class="video__player" :src="'https://www.youtube-nocookie.com/embed/'+ youtubeUrl +'?rel=0&amp;showinfo=0'"
            frameborder="0" allow="autoplay; encrypted-media" allowfullscreen v-if="youtubeUrl">
    </iframe>
    <video class="video__player" :src="videoUrl" controls v-if="videoUrl"></video>
  </div>
</template>

<script>
  export default {
    props: {
      cover: { default: '', },
      youtubeUrl: { type: String, default: '' },
      videoUrl: { type: String, default: '' },
    },
  }
</script>


<style lang="scss" scoped>

  .video {
    @include background-cover;
    &__player {
      @include size(100%, 570px);
      @media (max-width: 600px) {
        height: 300px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// components/articles/ArticleVideo.vue